module.exports = __webpack_public_path__ + "img/coupon-success.c919339.png";